const IconTemplateMenu = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="anticon"
    >
      <path
        d="M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM12.75 12.9375H5.25C4.9425 12.9375 4.6875 12.6825 4.6875 12.375C4.6875 12.0675 4.9425 11.8125 5.25 11.8125H12.75C13.0575 11.8125 13.3125 12.0675 13.3125 12.375C13.3125 12.6825 13.0575 12.9375 12.75 12.9375ZM12.75 9.5625H5.25C4.9425 9.5625 4.6875 9.3075 4.6875 9C4.6875 8.6925 4.9425 8.4375 5.25 8.4375H12.75C13.0575 8.4375 13.3125 8.6925 13.3125 9C13.3125 9.3075 13.0575 9.5625 12.75 9.5625ZM12.75 6.1875H5.25C4.9425 6.1875 4.6875 5.9325 4.6875 5.625C4.6875 5.3175 4.9425 5.0625 5.25 5.0625H12.75C13.0575 5.0625 13.3125 5.3175 13.3125 5.625C13.3125 5.9325 13.0575 6.1875 12.75 6.1875Z"
        fill="white"
      />
    </svg>
  )
}

export default IconTemplateMenu
